import * as React from 'react';
import { cn } from '../../lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn('ba-input', className)}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
